import {
    Carousel,
    Container,
} from "@peracto/peracto-blocks-tailwind";

export default {
    plugins: {
        content: [Carousel],
        layout: [Container],
    },
};
